module.exports = __webpack_public_path__ + "img/class_01.418406b8.png";